import { useContext } from 'react';
import { TemplateHistoryContext } from '../templates/PortalTemplate';

export const useTemplateHistory = () => {
    const history = useContext(TemplateHistoryContext);
    return history;
};
